import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { HeaderContainer } from '../global/HeaderContainer';
import NavContainer from '../global/NavContainer';
import Destination from'../Destination';
import Switcher from './Switcher';
import FooterContainer from '../global/FooterContainer';
import '../../css/global.scss';

const destinationData = {
  id: '202207-ge-cafe', // this id will be given to the div that wraps your destination markup.
  lander: {
    hed: "The Things I Wish I Added to My Wedding Registry",
    subhed: "And a few that left me questioning",
    subhed2: '“What was I thinking?”',
    text: "Steak knives. Cereal bowls. That cordless vacuum everyone raves about. It seems that your entire circle of friends (and acquaintances) have these items on their wedding registry. But…are they worth it? Before you stock up on too many white marble trays, consider these tips from PureWow staffers who have the privilege of a little perspective. Here is the one thing they each wish they added to their wedding registry, and one they wish they cut.",
    logo: "https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/ge-cafe-logo.png",
    metaDescription: 'Before you stock up on too many white marble trays, consider these tips from PureWow staffers on the one thing they wish they added to their wedding registry.',
    titleTag: '9 Things I Wish I Added to My Wedding Registry - PureWow',
    author: 'Angela Pares',
    bgImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/lander/lander_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/lander/lander_mobile.png',
      credit: 'Café Fearless Energy Kitchen',
    },
    archImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/lander/arch_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/lander/arch_mobile.png',
    }
  },
  sections: [{
    direction: 'right',
    color: 'dark',
    editor: 'Katherine Gillen',
    title: 'PureWow Food Editor',
    added: 'Does a <a href="https://www.zola.com/wedding-registry" target="_blank">honeymoon fund</a> count? Our wedding was so close to Christmas that we knew we weren’t going to take a trip right away...almost five years later and we’re *just* getting around to planning one. I think having a honeymoon fund would’ve motivated us to put something on the books sooner.',
    cut: 'Champagne flutes! They’re so delicate and I never use them, even when we have bubbly. I guess they’re a nice item to have if you entertain a lot, but I think a pretty <a href="https://food52.com/shop/products/8197-hand-blown-colored-cocktail-coupe-glasses" target="_blank">coupe-style cocktail glass</a> is a better, more versatile addition to a bar cart.',
    product: {
      name: 'Estelle Hand-Blown Colored Cocktail Coupe Glasses',
      cta: 'Buy It',
      url: 'https://food52.com/shop/products/8197-hand-blown-colored-cocktail-coupe-glasses',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-1_product-image.png'
    }
  }, {
    direction: 'right',
    color: 'light',
    editor: 'Cristina Gutierrez',
    title: 'Director, Branded Content',
    added: 'Instead of trendy cookware that didn’t last, I wish we invested in quality small appliances that have a stylish feel—like the pieces in the <a href="https://www.cafeappliances.com/countertop-appliances/" target="_blank">Café Expressions Collection</a>. Instead of unsightly, bulky, generic-looking countertop appliances, you’ll actually want to display these (rather than try and hide them behind a stack of cookbooks). They complement nearly any aesthetic and the functionality really holds up.',
    cut: 'I wish we cut more individual items in favor of gift cards! I would have loved options to <a href="https://www.framebridge.com/" target="_blank">Framebridge</a>, <a href="https://www.parachutehome.com/" target="_blank">Parachute</a> or <a href="https://www.airbnb.com/" target="_blank">Airbnb</a>. That way, we could have framed our wedding photos, waited to shop for linens until we moved into a new place and booked us some fun anniversary trips.',
   bgImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/featured/arch_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/featured/arch_mobile.png',
    },
    shoppable: [{
      name: 'Café Affetto Automatic Espresso Machine + Frother',
      cta: 'Buy It',
      url: 'https://www.cafeappliances.com/appliance/Cafe-AFFETTO-Automatic-Espresso-Machine-Frother-C7CEBBS3RD3',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/featured/ge_product_1.png'
    }, {
      name: 'Café Couture Oven with Air Fry',
      cta: 'Buy It',
      url: 'https://www.cafeappliances.com/appliance/Cafe-Couture-Oven-with-Air-Fry-C9OAAAS3RD3',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/featured/ge_product_2.png'
    }, {
      name: 'Café Bellissimo Semi-Automatic Espresso Machine',
      cta: 'Buy It',
      url: 'https://www.cafeappliances.com/appliance/Cafe-BELLISSIMO-Semi-Automatic-Espresso-Machine-Frother-C7CESAS4RW3',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/featured/ge_product_3.png'
    }, {
      name: 'Café Specialty Drip Coffee Maker',
      cta: 'Buy It',
      url: 'https://www.cafeappliances.com/appliance/Cafe-Specialty-Drip-Coffee-Maker-C7CDAAS3PD3',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/featured/ge_product_4.png'
    }],
  }, {
    direction: 'left',
    color: 'dark',
    editor: 'Emily Vandelanotte',
    title: 'Product Manager',
    added: 'I wish we added towels and bed linens. I didn’t have an actual wedding shower so I thought no one would buy that as a wedding present (seemed like more of a shower gift to me). I also was hesitant because, at the time, our apartment was so small and I wasn’t sure where we would store everything. But in hindsight, it’s so useful to have high quality bedding and towels—and we would have found a way to make it all fit!',
    cut: 'The fancy pepper and salt shakers. They were pricey and now we use other things to hold salt and pepper. Combined they were about $200 dollars, which could have been a gift card or something more useful.',
    product: {
      name: 'brooklinen Super-Plush Towels',
      cta: 'Buy It',
      url: 'https://www.brooklinen.com/collections/super-plush-towels',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-3_product-image.png'
    }
  }, {
    direction: 'right',
    color: 'dark',
    editor: 'Rachel Bowie',
    title: 'Director, Special Projects',
    added: 'Silverware. My husband and I had been living together for a couple of years at that point and already had silverware that had been given to us by my parents (it was my grandmother’s old set), so we decided we were all good in this category. I think we could have spent more time test driving styles. Silverware sets are expensive and, given we’re currently shopping for them now, we regret not asking for this staple item when we got married. It feels like a nice-to-have now versus what would have been an essential then.',
    cut: 'Trays for “entertaining.” Not kidding, I was hellbent on putting a pink Kate Spade platter on my registry. There was a registry glitch and I received three! I had to return two, was left with one and I have only used it once. I think it’s so easy to get caught up in the registry process and the “why not?” element of putting things on your list that other people will buy. But try to stick to those forever essentials will really set you up for the long haul of marriage and building a home. Back to the entertaining trays: As it turns out, my favorites in that category are ones that were gifted to me by choice or discovered (something my aunt personally selected or a platter I found in Portugal), not the random Kate Spade one.',
    product: {
      name: 'Cutipol Atlantico Polished Steel Flatware',
      cta: 'Buy It',
      url: 'https://www.graciousstyle.com/buy/cutipol-atlantico-polished-steel-flatware',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-4_product-image.png'
    }
  }, {
    direction: 'left',
    color: 'light',
    editor: 'Candace Davison',
    pinkClass: 'pink-background section-2',
    title: 'Executive Editor',
    added: 'Better pillows. Pillows are worth the splurge, because cheap ones will turn lumpy and pancake-flat in no time. <a href="https://www.purewow.com/home/purple-pillow-review" target="_blank">Purple’s Harmony and TwinCloud pillows</a> are so, so good—and trust me, I’ve tested more than a dozen brands over the years, ranging from $4 to over $200—and they really hold up. My husband’s so obsessed with the combo of comfort, support and breathability in his Harmony pillow that he actually travels with it. And I won’t let him live it down.',
    cut: 'Overpriced bedding. Fabrics have come a long way, and you can score super-soft bamboo (or brushed microfiber) sheets that are surprisingly affordable—and shockingly luxe-feeling. (There’s a reason this <a href="https://www.amazon.com/Mellanni-Bed-Sheet-Set-Hypoallergenic/dp/B00NLLUMOE/ref=asc_df_B00NLLUMOE/" target="_blank">Mellanni set</a> has 223K five-star reviews!)',
    product: {
      name: 'Purple Harmony Pillow',
      cta: 'Buy It',
      url: 'https://purple.com/pillows/harmony',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-5_product-image.png'
    }
  }, {
    direction: 'right',
    color: 'light',
    editor: 'Alyce Tassioni',
    title: 'Director, Brand Partnerships',
    added: 'Outdoor serving pieces, flatware and glassware. When we were engaged, we had a very small outdoor patio, so I wasn’t even thinking of outdoor entertaining. Now with a new home, backyard and deck, I wish I would have thought of fun pieces for outdoor entertaining like this <a href="https://www.potterybarn.com/products/natural-bamboo-flatware-set/?sku=9863664&cm_ven=PLA&cm_ite=9863664_14753423930&cm_cat=Google&cm_pla=Local&gclid=Cj0KCQjw2MWVBhCQARIsAIjbwoMRMF5yg-Sd8R6_qg3UpaXitM0f5tuZP0QNvPzPRJAKTDD1o8-u9koaAh7vEALw_wcB" target="_blank">set of bamboo flatware</a>, this <a href="https://www.potterybarn.com/products/chambray-tile-melamine-dinnerware-set/?pkey=cchambray-dinnerware" target="_blank">beautiful collection of plates and serveware</a>, and <a href="https://www.westelm.com/products/sole-outdoor-glassware-d8155/?catalogId=71&sku=8149356&cm_ven=PLA&cm_cat=Google&cm_pla=Kitchen%20%26%20Dining%20%3E%20Wine%20%26%20Champagne%20Glasses&region_id=668460&cm_ite=8149356_14465514686&gclid=Cj0KCQjw2MWVBhCQARIsAIjbwoNxeUW08KGvnHH4Begg9IUIM7XJdL4FEgPs5BaiuthaM2HDL4zazToaAkdtEALw_wcB" target="_blank">this bright and peppy set of acrylic wine glasses</a>.',
    cut: 'Gold dining room table linens. I prematurely decided on these before we were in our home and knew what our dining room would look like...or if we would ever even use a full-on gold table cloth. Maybe one day…',
    product: {
      name: 'Pottery Barn Chambray Tile Melamine Dinnerware Set',
      cta: 'Buy It',
      url: 'https://www.potterybarn.com/products/chambray-tile-melamine-dinnerware-set/?pkey=cchambray-dinnerware',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-6_product-image.png'
    }
  }, {
    direction: 'left',
    color: 'dark',
    editor: 'Mary D’Alessio',
    title: 'Audience Development Director',
    added: 'I didn’t add this to my registry, but someone purchased a hand-held steamer for me and I <i>highly</i> recommend it. We had a destination wedding so it was perfect to have on the big day to make sure everyone’s outfits were looking crisp and not right out of a suitcase.',
    cut: 'Cheese boards. Spoiler alert, you’re most likely going to get one anyway. Whether it’s a friend who loves Etsy and gets it personalized for you or a new in-law who buys you a monogrammed version, you’re probably going to get a few.',
    product: {
      name: 'The Nori Press',
      cta: 'Buy It',
      url: 'https://nori.co/products/the-nori-press',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-7_product-image.png'
    }
  }, {
    direction: 'right',
    color: 'dark',
    editor: 'Ali Gazan',
    title: 'Executive Producer',
    added: 'Art. I think I was so focused on the traditional registry and what I needed at that specific moment that I didn’t think of the bigger picture (pun intended). It would be really cool to have a piece that we got for our wedding that we could always hang in our home.',
    cut: 'Champagne flutes. They’re horrible to store. We never use them. Even when people have champagne or a mimosa we serve it in a wine glass. They’re easier to access and offer a bigger pour. Wins all around.',
    product: {
      name: 'Tappan Collective',
      cta: 'Buy It',
      url: 'https://www.tappancollective.com/',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-8_product-image.png'
    }
  }, {
    direction: 'left',
    color: 'light',
    pinkClass: 'pink-background section-3',
    editor: 'Catrina Yohay',
    title: 'Managing Editor',
    added: 'This may go against traditional advice, but I wish I focused on things we could use and enjoy now rather than guessing what we’d need in the future.',
    cut: 'So many oddly specific serving trays I have nowhere to store or reason to use. A glass cake dome because it was “cute.” All new bedding for a larger bed I’d assumed we’d have once we moved to a bigger place. (Spoiler: We haven’t yet.) All of that along with many other things are just sitting in my parents house—who are, at least, kind enough to store it (it is a literal mountain of boxes, and honestly I’ve forgotten about most of what’s in them).',
    product: {
      name: 'Solo Stove Fit Pit',
      cta: 'Buy It',
      url: 'https://www.solostove.com/solo-stove-bonfire/',
      image: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/editor-9_product-image.png'
    }
  }],
  pinkImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/pink_background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ge-cafe/pink_background_mobile.png',
  },
};

class AppView extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // For SSR, isMobile is always true. For client render, isMobile's value is determined by the result of the dispatch below.
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        dispatch({
          type: 'MOBILE_DETERMINE',
        });
      });

      dispatch({
        type: 'MOBILE_DETERMINE',
      });
    }
  }

  render() {
    const { isClient, isMobile } = this.props;

    /*
      To prevent flashes on desktop (i.e. because the mobile layout will render first), we can apply an opacity of 0 in cases where isClient is false
      (i.e. for the SSR). The server-rendered markup is set to the client where, on componentDidMount(), we dispatch an action that updates both
      isMobile (window.innerWidth <= 991) and isClient (true). Now that isClient is true, the div wrapping the App children below will have opacity 1.
    */
    return (
      <Fragment>
      <div className="app" style={{ opacity: isClient ? 1 : 0 }}>
        <HeaderContainer />
        <NavContainer />
        <div className="content">
          { isClient &&
            <Destination {...destinationData} isMobile={isMobile}/>
          }
          <Switcher />
        </div>
      </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ isClient, isMobile }) => ({
  isClient,
  isMobile,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const App = connect(mapStateToProps, mapDispatchToProps)(AppView);

export default App;
